module.exports = __webpack_public_path__ + "static/luz-min.83f41cf7.jpg";